export const CREATE_STORY_PAGE = 'CREATE_STORY_PAGE';
export const UPDATE_STORY_PAGE = 'UPDATE_STORY_PAGE';
export const MOVE_STORY_PAGE = 'MOVE_STORY_PAGE';
export const LINK_STORY_PAGES = 'LINK_STORY_PAGES';
export const UNLINK_STORY_PAGES = 'UNLINK_STORY_PAGES';
export const CHANGE_PAGE_ORIENTATION = 'CHANGE_PAGE_ORIENTATION';
